export default function Terms() {
  return (
    <div className="page">
      <h1>Terms of Service</h1>

      <p>By using this platform, you agree to the following:</p>

      <ul>
        <li>You provide accurate information</li>
        <li>You are responsible for your account</li>
        <li>No misuse of the system</li>
      </ul>
    </div>
  );
}
